import { Controller } from "@hotwired/stimulus"

// MS50 #3410 -- Stimulus "template-scope" controller.
//
// The job-template form asks whether a template is available company-wide or
// only to specific divisions. The division checklist is meaningful for the
// second choice only, so it is revealed/hidden as the radio group changes.
//
// This is a convenience, never the enforcement: the server normalizes the
// choice (JobTemplate#normalize_visibility_scope clears division_ids for a
// company-wide template, and JobTemplatesController#scoped_job_template_params
// resolves every submitted id through the actor's own scope), so a browser with
// JavaScript disabled or a forged POST cannot store the both-set shape.
//
// The wrapper is server-rendered with .d-none unless the "divisions" branch is
// already selected, and connect() runs on initial load AND after every Turbo
// render -- so the 422 re-render after a validation failure comes back with the
// checklist open on the choice the user actually made.
//
// Usage in view:
//   <fieldset data-controller="template-scope">
//     <input type="radio" name="job_template[visibility_scope]" value="company"
//            data-action="change->template-scope#toggle">
//     <input type="radio" name="job_template[visibility_scope]" value="divisions"
//            data-action="change->template-scope#toggle">
//     <div data-template-scope-target="divisions" class="d-none">...</div>
//   </fieldset>
//
export default class extends Controller {
  static targets = ["divisions"]

  connect() {
    this.toggle()
  }

  // change-> handler on both radios, plus the initial connect() call.
  toggle() {
    if (!this.hasDivisionsTarget) {
      return
    }

    this.divisionsTarget.classList.toggle("d-none", !this.divisionsScopeSelected)
  }

  // True only when the checked radio in this fieldset is the divisions branch.
  get divisionsScopeSelected() {
    const chosen = this.element.querySelector(
      "input[type=radio][name$='[visibility_scope]']:checked"
    )
    return chosen ? chosen.value === "divisions" : false
  }
}
